import { render } from "./Step_4.vue?vue&type=template&id=07dc8c04"
import script from "./Step_4.vue?vue&type=script&lang=js"
export * from "./Step_4.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__